export default {
    and: 'and',
    option: 'option',
    options: 'options',
    fewer: 'fewer',
    more: 'more',
    pageAvailableIn: 'This page is available in',
    bookAvailableIn: 'This textbook is available in',
    weHaveBooksIn: 'We have textbooks in',
    weAlsoHave: 'We also have books in',
    getTheBook: 'Get the book',
    summary: 'Summary',
    recommended: 'Recommended',
    view: 'View',
    viewAll: 'All',
    'tabs.bookDetails': 'Book details',
    'tabs.instructorResources': 'Instructor resources',
    'tabs.studentResources': 'Student resources',
    'tabs.videos': 'Videos',
    'adoption.book-prompt': 'Which textbook(s) are you currently using?',
    'adoption.instructions': 'Select titles you are using even if the edition number is different.',
    'authors.senior': 'Senior Contributing Authors',
    'authors.contributing': 'Contributing Authors',
    'book-selector.select': 'Select up to {limit}',
    'book-selector.select-more': 'Select up to {limit} more',
    'contact-info.first-name': 'First name',
    'contact-info.last-name': 'Last name',
    'contact-info.email': 'Email address',
    'contact-info.phone': 'Phone number',
    'contact-info.school': 'School name',
    'contact-info.school-not-found': 'We don\'t have that school in our system.' +
        ' Please tell us a little more about it:',
    'contact-info.school-type-label': 'What type of school is it?',
    'contact-info.school-location-label': 'Is it located in the United States?',
    'errata.header': 'Errata',
    'errata.suggest': 'Suggest a correction',
    'errata.list': 'Errata list',
    'form.back': 'Back',
    'form.next': 'Next',
    'form.submit': 'Submit',
    'form.step-of': 'Step {current} of {total}',
    'resources.additional': 'see additional resources below',
    'resources.loginToUnlock': 'Login to unlock',
    'getit.toc': 'Table of contents',
    'getit.webview.link': 'View online',
    'getit.app': 'Download the app',
    'getit.pdf.download': ' Download a PDF',
    'getit.pdf.sample': ' sample',
    'getit.print': 'Order a print copy',
    'getit.kindle.header': 'Download for Kindle',
    'getit.kindle.disclaimer': 'As an Amazon Associate we earn from qualifying purchases',
    'how-using.how-many': 'How many students are using {title} each semester?',
    'how-using.hint': 'Include sections taught by TAs that you oversee',
    'how-using.how-using': 'How are you using {title}?',
    'how-using.students-label': 'Students per semester',
    'how-using.usage-label': 'How are you using this book?',
    'how-using.core': 'As the core textbook for my course',
    'how-using.recommended': 'As an optional/recommended textbook for my course',
    'how-using.outside': 'To teach, tutor, or support students outside of a course setting',
    'interest.option.Web search': 'Web search',
    'interest.option.Colleague': 'Colleague',
    'interest.option.Conference': 'Conference',
    'interest.option.Email': 'Email',
    'interest.option.Facebook': 'Facebook',
    'interest.option.Twitter': 'X',
    'interest.option.Webinar': 'Webinar',
    'interest.option.Partner organization': 'Partner organization',
    'interest.how': 'How did you hear about OpenStax?',
    'interest.select-instruction': 'Select all that apply (optional).',
    'interest.books-prompt': 'Which textbook(s) are you interested in using?',
    'interest.students-prompt': 'How many students do you teach each semester?',
    'how-using.self': 'For my own knowledge or other work',
    'expander.fewer': 'See {optionCount} fewer {options}',
    'expander.more': '+ {optionCount} more {options}...',
    'letusknow.text1': 'Sign up to<br>learn more',
    'letusknow.text2': 'Using this book?<br>Let us know.',
    'printcopy.individual': 'Individual',
    'printcopy.disclosure': '***',
    'printcopy.bookstore': 'Bookstore',
    'printcopy.audiobook': 'Audiobook',
    'printcopy.button1': 'Buy a print copy',
    'printcopy.button2': 'Order options',
    'printcopy.audiobook-button': 'Purchase options',
    'pubInfo.pdf.heading': 'PDF Version Last Updated:',
    'pubInfo.pdf.see': 'See changes in the',
    'pubInfo.pdf.notes': 'Revision Notes',
    'pubInfo.license': '{title} by OpenStax is licensed under {name} v{version}',
    'pubInfo.license.heading': 'License',
    'pubInfo.pub.pub': 'Publish Date:',
    'pubInfo.pub.web': 'Web Version Last Updated:',
    'pubInfo.pub.color': 'Color',
    'pubInfo.pub.b-w': 'Black and White',
    'pubInfo.pub.dig': 'Digital PDF',
    'pubInfo.pub.assignable': 'Assignable Courseware',
    'school-type.College/University (4)': 'College/University (4)',
    'school-type.Technical/Community College (2)': 'Technical/Community College (2)',
    'school-type.Career School/For-Profit (2)': 'Career School/For-Profit (2)',
    'school-type.High School': 'High School',
    'school-type.K-12 School': 'K-12 School',
    'school-type.Home School': 'Home School',
    'school-type.Other': 'Other',
    'selector.select-one': 'Please select one',
    'student-form:message': 'Students don\'t need to fill out any forms to use our books. Access them free now!',
    'student-form:go-back': 'Go back',
    'subject.categoryTitle': '{subjectName} Book Categories',
    'subject.learnMoreTitle': 'Learn more',
    'subject.introText': 'Open textbooks',
    'subject.noBlog': 'No blog entries found (yet)',
    'subject.noWebinars': 'No webinars found (yet)',
    'subject.viewAll': 'View all {subject} books',
    'subject.notAvailableText': 'Subject not found.',
    'subject.notAvailableLinkText': 'View all',
    'resources.available': 'Only available for verified instructors.',
    'role-selector.i-am': 'I am a',
    'yes': 'Yes',
    'no': 'No'
};
